
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.704 2.225a1.5 1.5 0 012.592 0l2.25 3.864a1.5 1.5 0 00.98.711l4.37.947a1.5 1.5 0 01.8 2.465l-2.979 3.335a1.5 1.5 0 00-.373 1.15l.45 4.449a1.5 1.5 0 01-2.097 1.524l-4.092-1.804a1.5 1.5 0 00-1.21 0L7.303 20.67a1.5 1.5 0 01-2.097-1.524l.45-4.449a1.5 1.5 0 00-.373-1.15l-2.98-3.335a1.5 1.5 0 01.801-2.465l4.37-.947a1.5 1.5 0 00.98-.71l2.25-3.865z","fill":"#FFC239"}})])
          )
        }
      }
    